import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import MediumModal from "../../../../components/modals/MediumModal";
import {
  closeLabOrderFileResultModal,
  openLabOrderGeneralResultModal,
} from "../../../../redux/actions/modals";
import { sendLabOrderResult } from "../../../../redux/actions/orders";
import {
  uploadLabOrderResult,
  uploadLabOrderResultEmpty,
} from "../../../../redux/actions/upload";
import toaster from "../../../../utils/toaster";
const SendLabFileResultComponent = (props) => {
  const dispatch = useDispatch();
  const { file_lab_result_order_open, file_result_lab_order } = useSelector(
    (state) => state.modals
  );
  const { upload_lab_order_result_success, upload_lab_order_result_waiting } =
    useSelector((state) => state.upload);
  const { send_lab_order_result_waiting } = useSelector(
    (state) => state.orders
  );
  const [files, setFiles] = useState([]);
  const [filesPreview, setFilesPreview] = useState({});
  const [filesToSend, setFilesToSend] = useState([]);
  useEffect(() => {
    if (
      upload_lab_order_result_success.result &&
      upload_lab_order_result_success.data.result === "SUCCESS"
    ) {
      let fileID = upload_lab_order_result_success.data.fileID;
      let fileAddress = upload_lab_order_result_success.data.fileAddress;
      let currentFilesToSend = filesToSend;
      currentFilesToSend.push({
        fileID: fileID,
        fileAddress: fileAddress,
      });
      setFilesToSend(currentFilesToSend);
      const newFileData = { ...filesPreview, fileID };
      setFilesPreview(newFileData);
      const indexOfNewFiles = files.findIndex(
        (element) =>
          element.file.size === filesPreview.file.size &&
          element.file.name === filesPreview.file.name
      );
      const filesOutId = [...files];
      filesOutId[indexOfNewFiles] = { ...filesOutId[indexOfNewFiles], fileID };
      toaster.success("آپلود موفق");
      setFiles(filesOutId);
      dispatch(uploadLabOrderResultEmpty());
    } else if (
      upload_lab_order_result_success.result &&
      upload_lab_order_result_success.data.result !== "SUCCESS"
    ) {
      toaster.error(upload_lab_order_result_success.data.message);
    }
  }, [upload_lab_order_result_success]);
  const submit = () => {
    if (filesToSend.length === 0) {
      toaster.warning("ابتدا فایل مورد نظر را اضافه نمایید.");
      return;
    }
    let body = {
      method: "files",
      files: filesToSend,
    };
    dispatch(sendLabOrderResult(file_result_lab_order.id, body));
  };

  const limitedCharecters = (string) => {
    const newString =
      string.length > 7 ? string.substring(0, 7).concat("...") : string;
    return newString;
  };

  const removeFileFromSendItems = (id) => {
    const removedArraySend = filesToSend.filter(
      (element) => element.fileID !== id
    );
    const removedArrayFiles = files.filter((element) => element.fileID !== id);
    setFilesToSend(removedArraySend);
    setFiles(removedArrayFiles);
  };
  useEffect(() => {
    setFiles([]);
    setFilesPreview({});
    setFilesToSend([]);
  }, [props]);

  return (
    <MediumModal
      header="بارگذاری فایل نتیجه آزمایش"
      show={file_lab_result_order_open}
      closeFunction={closeLabOrderFileResultModal}
    >
      <div className="lab-direct-result-form-holder">
        <div className="form-holder">
          <div className="form-group row">
            <div className="col-sm-12">
              <button
                className="btn btn-small btn-success text-white full-width"
                onClick={() => {
                  document.getElementById("upload-result").click();
                }}
                disabled={upload_lab_order_result_waiting}
              >
                بارگذاری فایل نتیجه
              </button>
              <input
                type="file"
                className="form-control"
                style={{ display: "none" }}
                id="upload-result"
                onChange={(e) => {
                  if (e.target.files.length !== 0) {
                    let file = e.target.files[0];
                    let url = URL.createObjectURL(file);
                    const newObjFile = { file, url };
                    setFiles((prevState) => [...prevState, newObjFile]);
                    setFilesPreview(newObjFile);
                    let user = JSON.parse(localStorage.getItem("user"));
                    dispatch(
                      uploadLabOrderResult({ file: file, userId: user.id })
                    );
                  }
                }}
              />
            </div>
            <div className="col-lg-12 lab-result-images-holder">
              <div className="row">
                {files.map((file, index) => {
                  if (file.fileID !== undefined && file.fileID !== null) {
                    return (
                      <div
                        className="col-lg-4 col-md-4 col-sm-6 file-uploaded-drug-holder"
                        key={index}
                      >
                        <a
                          className="btn btn-sm btn-primary text-13"
                          target={"_blank"}
                          href={file.url}
                        >
                          نمایش فایل {file.file.name}
                        </a>
                        <div
                          onClick={() => {
                            removeFileFromSendItems(file.fileID);
                          }}
                        ></div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
          <div className="form-group row sampling-order-action-buttons mb-0">
            <div className="col-sm-6 mb-3">
              <CustomButton
                action={submit}
                loading={
                  send_lab_order_result_waiting ||
                  upload_lab_order_result_waiting
                }
                content={"تایید و ارسال"}
                type={"success"}
                block={true}
                textWhite={true}
              />
            </div>
            <div className="col-sm-6 mb-3">
              <button
                className="btn btn-small btn-outline-black full-width"
                onClick={() => {
                  dispatch(closeLabOrderFileResultModal());
                  dispatch(
                    openLabOrderGeneralResultModal(file_result_lab_order)
                  );
                  setFiles([]);
                  setFilesPreview({});
                  setFilesToSend([]);
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    </MediumModal>
  );
};
export default SendLabFileResultComponent;
